<template>
  <div class="detail-container">
    <div class="title-box">
      <div class="name">基本配置</div>
      <div class="border"></div>
    </div>
    <ul class="form">
      <li class="form-item">
        <span class="key">站点名称</span>
        <span class="value"> {{ detail.spiderName }}</span>
      </li>
      <li class="form-item">
        <span class="key">国家</span>
        <span class="value">{{ detail.countryName }}</span>
      </li>
      <li class="form-item">
        <span class="key">站点地址</span>
        <span class="value">
          <a-tag v-for="item in detail.spiderUrls" :key="item">{{ item }}</a-tag>
        </span>
      </li>
      <li class="form-item">
        <span class="key">语言</span>
        <span class="value">{{ detail.langName }}</span>
      </li>
      <li class="form-item">
        <span class="key">部署区域</span>
        <span class="value">{{ detail.deployTypeName }}</span>
      </li>
      <li class="form-item">
        <span class="key">爬虫深度</span>
        <span class="value">{{ formatLevel(detail.spiderLevel) }}</span>
      </li>
      <li class="form-item">
        <span class="key">调度周期</span>
        <span class="value">{{ detail.spiderExecTimeCycle }}</span>
      </li>
      <li class="form-item">
        <span class="key">标签设置</span>
        <span class="value">
          <a-tag size="large" v-for="(item, index) in detail.spiderTags" :key="index">
            {{ item.spiderTagName }}
          </a-tag>
        </span>
        <!-- <span class="value">{{ detail.spiderName }}</span> -->
      </li>
    </ul>

    <div class="title-box">
      <div class="name">黑白名单配置</div>
      <div class="border"></div>
    </div>
    <ul class="form">
      <li class="form-item">
        <span class="key">域名（黑名单）</span>
        <span class="value">
          <a-tag v-for="item in blackConfig.hosts" :key="item">{{ item }}</a-tag>
        </span>
      </li>
      <li class="form-item">
        <span class="key">域名（白名单）</span>
        <span class="value">
          <a-tag v-for="item in whiteConfig.hosts" :key="item">{{ item }}</a-tag>
        </span>
      </li>
      <li class="form-item"></li>
      <li class="form-item">
        <span class="key">路径（黑名单）</span>
        <span class="value">
          <a-tag v-for="item in blackConfig.paths" :key="item">{{ item }}</a-tag>
        </span>
      </li>
      <li class="form-item">
        <span class="key">路径（白名单）</span>
        <span class="value">
          <a-tag v-for="item in whiteConfig.paths" :key="item">{{ item }}</a-tag>
        </span>
      </li>
    </ul>

    <div class="title-box">
      <div class="name">高级配置</div>
      <div class="border"></div>
    </div>
    <ul class="form">
      <li class="form-item">
        <span class="key">并发数</span>
        <span class="value">{{ detail.synNum }}</span>
      </li>
      <li class="form-item">
        <span class="key">时间间隔</span>
        <span class="value">{{ detail.synCycle }}</span>
      </li>
      <li class="form-item">
        <span class="key">重试次数</span>
        <span class="value">{{ detail.retryNum }}</span>
      </li>
      <li class="form-item">
        <span class="key">超时时间（ms）</span>
        <span class="value">{{ detail.timeOut }}</span>
      </li>
    </ul>

    <div class="title-box">
      <div class="name">解析配置</div>
      <div class="border"></div>
    </div>
    <ul class="form">
      <li class="form-item">
        <span class="key">选择器名称</span>
        <span class="value"> {{ spiderParse.spiderParseTypeName }}</span>
      </li>
    </ul>
    <ul class="form" style="position: relative">
      <li class="form-item">
        <span class="key">解析规则</span>
        <ul
          class="tab-container"
          v-if="spiderParse.spiderParseConfigs && spiderParse.spiderParseConfigs.length > 1"
        >
          <li
            :class="isCur === index ? 'tab-box active-box' : 'tab-box'"
            @click="isCur = index"
            v-for="(item, index) in spiderParse.spiderParseConfigs"
          >
            {{ index + 1 }}
          </li>
        </ul>
      </li>
    </ul>
    <template v-for="(item, i) in spiderParse.spiderParseConfigs">
      <table v-if="isCur === i" :key="item.spiderParseId" border="1">
        <tr>
          <td class="value" style="width: 150px">匹配路径</td>
          <td>
            <span v-for="url in item.urls">{{ url }}</span>
          </td>
        </tr>
        <tr v-for="(inner, index) in item.spiderConfigs" :key="index">
          <td
            v-if="index < 1"
            class="value"
            :rowspan="index === 0 ? item.spiderConfigs.length + 1 : 1"
            style="width: 150px"
          >
            字段解析
          </td>
          <td class="text-left">
            <span class="key">{{ inner.name }}：</span>
            <span class="value">{{ inner.rule }}</span>
          </td>
        </tr>
      </table>
    </template>
  </div>
</template>

<script>
import { getSpiderApiByIdApi } from '@/api/Site/Create'
import { getSpiderDetailById } from '@/api/Site/Info'

export default {
  name: 'Config',
  props: {
    type: {
      default: ''
    },
    id: {
      default: ''
    }
  },
  data() {
    return {
      basic: {
        name: '多党领袖网',
        wey: '国内'
      },
      detail: {},
      blackConfig: [],
      whiteConfig: [],
      spiderParse: {},
      isCur: 0
    }
  },
  created() {
    this.getSingleDetail()
  },
  methods: {
    reload() {
      this.getSingleDetail()
    },
    getSingleDetail() {
      // 新闻
      if (this.type === 'news') {
        getSpiderDetailById({ spiderId: this.id, type: this.type }).then((res) => {
          if (res.code === 200) {
            this.detail = res.extra.data
            // 黑白名单和解析器配置数据
            this.blackConfig = res.extra.data.blackConfig
            this.whiteConfig = res.extra.data.whiteConfig
            this.spiderParse = res.extra.data.spiderParse
          }
        })
      } else {
        getSpiderApiByIdApi({ spiderId: this.id, type: this.type }).then((res) => {
          if (res.code === 200) {
            this.detail = res.extra.data
            this.blackConfig = res.extra.data.blackConfig
            this.whiteConfig = res.extra.data.whiteConfig
            this.spiderParse = res.extra.data.spiderParse
          }
        })
      }
    },
    formatLevel(data) {
      switch (data) {
        case -1:
          return '全部'
        case 1:
          return '一层'
        case 2:
          return '二层'
        case 3:
          return '三层'
        case 4:
          return '四层'
        case 5:
          return '五层'
        default:
          break
      }
    }
  }
}
</script>

<style scoped lang="less">
.detail-container {
  background: #fff;
  padding: 20px;

  .title-box {
    display: flex;
    margin-bottom: 30px;
    font-weight: bold;
    .name {
      border-left: 2px solid #1890ff;
      padding: 0 8px;
      height: 14px;
      line-height: 14px;
    }
    .border {
      border-bottom: 1px solid #ebebeb;
      flex: 1;
      position: relative;
      top: -6px;
    }
  }

  .form {
    display: grid;
    grid-template-columns: repeat(3, 33.33%);
    grid-row-gap: 20px;
    margin-bottom: 40px;
    .form-item {
      display: flex;
    }
    .key {
      color: #bbbbbb;
      margin-right: 10px;
      display: inline-block;
      width: 110px;
      text-align: right;
    }
    .value {
      color: #6d707e;
      flex: 1;
    }
    .ant-tag {
      margin-bottom: 10px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      max-width: 300px;
    }
  }
}

table {
  width: 100%;
  border-color: #e2e2e2;
}
tr {
  min-height: 50px;
  line-height: 50px;
  td {
    padding-left: 15px;
    font-size: 14px;
  }
  .key {
    display: inline-block;
    width: 100px;
    text-align: right;
    color: #bbbbbb;
  }
  .value {
    color: #333;
  }
}
.tab-container {
  position: absolute;
  display: flex;
  right: 0;
  bottom: -30px;
}
.tab-box {
  width: 36px;
  height: 36px;
  line-height: 36px;
  text-align: center;
  border: 1px solid #e2e2e2;
  cursor: pointer;
}
.active-box {
  border-color: #1890ff;
  color: #1890ff;
}
</style>
<style>
.detail-container .form .ant-tag {
  margin-bottom: 0;
}
</style>
.detail-container .form .ant-tag
